import state from '~store/modules/dashboards/state'
import actions from '~store/modules/dashboards/actions'

export default {
  state,
  actions
}
